import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { Capabilities } from '../components/Capabilities';
import { SapperStandard } from '../components/SapperStandard';
import { BrandStrip } from '../components/BrandStrip';
import { ServiceAreas } from '../components/ServiceAreas';
import { CaseFiles } from '../components/CaseFiles';
import { EstimateBanner } from '../components/EstimateBanner';
import { Testimonials } from '../components/Testimonials';
import { Financing } from '../components/Financing';
import { MissionForm } from '../components/MissionForm';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen bg-sapper-dark text-sapper-white font-sans selection:bg-sapper-red selection:text-white" data-id="element-384">
      <Header data-id="element-385" />
      <main data-id="element-386">
        <Hero data-id="element-387" />
        <Capabilities data-id="element-388" />
        <SapperStandard data-id="element-389" />
        <BrandStrip data-id="element-390" />
        <ServiceAreas data-id="element-391" />
        <CaseFiles data-id="element-392" />
        <EstimateBanner data-id="element-393" />
        <Testimonials data-id="element-394" />
        <Financing data-id="element-395" />
        <MissionForm data-id="element-396" />
      </main>
      <Footer data-id="element-397" />
    </div>;
}